export const OPEN_MOBILE_CATALOG_EVENT = 'open-mobile-catalog';
export const CLOSE_MOBILE_CATALOG_EVENT = 'close-mobile-catalog';
export const MOBILE_CATALOG_VISIBILITY_EVENT = 'mobile-catalog-visibility';
export const MOBILE_SEARCH_VISIBILITY_EVENT = 'mobile-search-visibility';
export const OPEN_MOBILE_SEARCH_EVENT = 'open-mobile-search';
export const CLOSE_MOBILE_SEARCH_EVENT = 'close-mobile-search';
